import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    container: {
        minHeight: '100vh',
        display: 'flex',
    },
    mainContent: {
        flexGrow: 1,
        maxWidth: '100%',
        overflowX: 'hidden',
    },
    base: {
        height: '100%',
        width: '100%',
        backgroundColor: theme.palette.primary.main,
    },
    root: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(0, 2),
    },
    card: {
        width: '420px',
        maxWidth: '100%',
        overflow: 'visible',
        display: 'flex',
        position: 'relative',
        '& > *': {
            flexGrow: 1,
            flexBasis: '50%',
            width: '50%',
        },
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: theme.spacing(6),
    },
    title: {
        fontSize: '18px',
        fontWeight: 'bold',
        marginTop: '36px',
        color: '#444',
    },
    divider: {
        margin: theme.spacing(1, 0),
        width: '100%',
    },
    dialogTitle: {
        background: theme.palette.primary.main,
        color: 'white',
        fontWeight: 'bold',
    },
    linksContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        gap: '10px',
    },
}));
